import getScreenWidth from '../dom-utils/getScreenWidth';
import { useCallback, useEffect, useState } from 'react';
import getGlobal from '../shared/getGlobal';
import getWidthByUA from '../shared/getWidthByUA';

export default function useScreenWidth(ua: string | undefined): number {
    return useScreenWidthWithTrigger(ua)[0];
}

let onceScreenWidthNotMatchedLog!: boolean;
export function useScreenWidthWithTrigger(ua: string | undefined, options?: {
    listenOrientatinonChange: boolean;
}): [width: number, trigger: () => void] {
    // 初始化时有ua就用ua来获取宽度，没有的话就走document来获取
    const [state, setState] = useState(getWidthByUA(ua));

    useEffect(() => {
        const clientScreenWidth = getScreenWidth();
        if (state !== clientScreenWidth) {
            setState(clientScreenWidth);
            if (!onceScreenWidthNotMatchedLog) {
                console.warn('server ua can\'t get correct screenWidth');
                onceScreenWidthNotMatchedLog = true;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onResize = useCallback(() => {
        setState(getScreenWidth());
    }, []);

    useEffect(() => {
        const globalVar = getGlobal();
        globalVar.addEventListener('resize', onResize);
        const listenOrientatinonChange = options?.listenOrientatinonChange;
        if (listenOrientatinonChange) {
            globalVar.addEventListener('orientationchange', onResize);
        }
        return () => {
            globalVar.removeEventListener('resize', onResize);
            if (listenOrientatinonChange) {
                globalVar.removeEventListener('orientationchange', onResize);
            }
        };
    }, [onResize, options?.listenOrientatinonChange]);

    return [state, onResize];
}
